import Vue from "vue";

import { DEFAULT_IMAGE_URL } from "@/common/constants";

const LOADING_SRC = "/loading.gif";
const DEFAULT_RETRY_DELAY = 1000;
const DEFAULT_MAX_RETRIES = 8; // backoff 1s..4s acumula ~20s en 8 pasos
const DEFAULT_MAX_TOTAL_MS = 20000;

const backoffDelay = (attempt, retryDelay) =>
    Math.min(retryDelay * 2 ** attempt, 4000);

const startLoading = (el, binding) => {
    const targetSrc = el.src;
    if (!targetSrc) return;

    const options = binding.value || {};
    const retryDelay = options.retryDelay || DEFAULT_RETRY_DELAY;
    const maxRetries = options.maxRetries || DEFAULT_MAX_RETRIES;
    const fallbackSrc = options.fallbackSrc || DEFAULT_IMAGE_URL;

    el.src = LOADING_SRC;
    el.classList.add("object-contain");
    el.__imgLoadingState = { cancelled: false, timeoutId: null };

    let attempt = 0;
    const startedAt = Date.now();

    const attemptLoad = () => {
        const state = el.__imgLoadingState;
        if (!state || state.cancelled) return;

        const probe = new Image();
        probe.src = targetSrc;
        probe.onload = () => {
            if (!el.__imgLoadingState || el.__imgLoadingState.cancelled) return;
            el.classList.remove("object-contain");
            el.src = targetSrc;
        };
        probe.onerror = () => {
            if (!el.__imgLoadingState || el.__imgLoadingState.cancelled) return;
            attempt += 1;
            const elapsed = Date.now() - startedAt;
            if (attempt > maxRetries || elapsed >= DEFAULT_MAX_TOTAL_MS) {
                el.classList.remove("object-contain");
                el.src = fallbackSrc;
                return;
            }
            state.timeoutId = setTimeout(
                attemptLoad,
                backoffDelay(attempt, retryDelay)
            );
        };
    };

    attemptLoad();
};

const stopLoading = (el) => {
    const state = el.__imgLoadingState;
    if (state) {
        state.cancelled = true;
        if (state.timeoutId) clearTimeout(state.timeoutId);
    }
};

export default Vue.directive("img-loading", {
    inserted: startLoading,
    unbind: stopLoading
});
